;
$(document).ready(function () {

    window.app = new App();
    window.app.init();

});


var App = function () {
};

App.prototype.init = function () {
    var self = this;
    $.nette.init();

    $.nette.ext('animateAjax', {
        before: function () {
            $('.animateAjax').prepend('<span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span>');
            $('.animateAjax').prop("disabled", true);
        },
        success: function () {
            $('.animateAjax').find('.glyphicon').remove();
            $('.animateAjax').prop("disabled", false);

            self.reload();
        }
    }, {});


    self.reload();
    this.initSlider();
};

App.prototype.reload = function () {

};

App.prototype.initSlider = function () {
    if ($('#type-cars-carousel').length != 0) {
        $("#type-cars-carousel").owlCarousel({
            autoPlay: true,
            items: 4,
            margin: 40,
            nav: true,
            navText: [,],
            navRewind: false,
            loop: true,
            responsive: {
                0: {
                    items: 1,
                },
                992: {
                    items: 2,
                    margin: 0,
                },
                1240: {
                    items: 3,
                    margin: 0,
                },
                1380: {
                    items: 4,
                    margin: 40,
                },
            }
        });
    }
    if ($('#recent-cars-carousel').length != 0) {
        $("#recent-cars-carousel").owlCarousel({
            items: 3,
            margin: 20,
            nav: true,
            navText: [,],
            navRewind: false,
            responsive: {
                0: {
                    items: 1,
                },
                700: {
                    items: 2,
                },
                992: {
                    items: 3,
                    margin: 10,
                },
                1240: {
                    items: 3,
                    margin: 10,
                },
                1380: {
                    items: 3,
                    margin: 20,
                },
            },
        });
    }
};

